import { GuestAccessState } from '../services/Identity';

export const GUEST_ONBOARDING_PATH = '/guest/complete-profile';
export const GUEST_PENDING_PATH = '/guest/pending';
export const GUEST_MEMBERSHIP_PATH = '/payments';
export const GUEST_HOME_PATH = '/home';

const GUEST_PROFILE_PATH = '/manage-profiles';

/*
    A guest whose access is not active yet is held on /guest/pending, which explains whichever
    gate is still closed (staff verification, then membership). Only these paths stay reachable
    while they wait - plus /payments (see canGuestReachPath).
*/
export const GUEST_HOLDING_PATHS = [GUEST_PENDING_PATH, GUEST_ONBOARDING_PATH, GUEST_PROFILE_PATH];

type PartialGuestAccess = Partial<GuestAccessState> | null | undefined;

export const isGuestVerified = (access: PartialGuestAccess): boolean => Boolean(access && access.verified);

export const isGuestAccessActive = (access: PartialGuestAccess): boolean => Boolean(access && access.active);

/*
    F12: the one rule for which routes a guest can open, shared by PrivateRoute and the sidebar
    so a nav entry never leads to a redirect. /payments is open to every onboarded guest, even
    unverified: they still need card removal, history, cancel and disputes. The page itself
    hides the commitment actions (create membership, add card, resume) until they're verified.
*/
export const canGuestReachPath = (path: string, access: PartialGuestAccess): boolean => {
    if (isGuestAccessActive(access)) return true;
    return GUEST_HOLDING_PATHS.includes(path) || path === GUEST_MEMBERSHIP_PATH;
};

/*
    Single source of truth for where a guest belongs after signing in, completing onboarding,
    or being bootstrapped on a page load. Keep every guest redirect going through here so the
    three entry points cannot drift apart.
*/
export const resolveGuestLandingPath = (access: PartialGuestAccess, needsOnboarding?: boolean): string => {
    if (needsOnboarding) return GUEST_ONBOARDING_PATH;
    if (!isGuestAccessActive(access)) return GUEST_PENDING_PATH;
    return GUEST_HOME_PATH;
};
